import { styled } from '@mui/system';
import { CSSProperties } from 'react';

import { Card, CardProps } from '@/components/layout/Card/Card';
import { COLORS } from '@/styles/tokens/colors';

export const Footer = styled('footer')<{
  borderTop?: CSSProperties['borderTop'];
}>(({ borderTop = `1px solid ${COLORS.GRAY[200]}` }) => ({
  padding: '12px 16px',
  borderTop,
  display: 'flex',
  justifyContent: 'flex-end',
  gap: '12px',
}));

export const Content = styled('div', {
  shouldForwardProp: (prop) => prop !== 'centerEmptyState',
})<{ centerEmptyState?: boolean }>(({ centerEmptyState }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  padding: '16px',
  gap: '16px',
  overflow: 'auto',
  height: '100%',
  ...(centerEmptyState && {
    // Grow only the empty state's container path. Tabs and filters stay at the top.
    '&:has([data-action-card-variant="noCard"]), & :has([data-action-card-variant="noCard"])':
      {
        display: 'flex',
        flexDirection: 'column',
        flexGrow: 1,
      },
    '& :has([data-action-card-variant="noCard"])': {
      flexShrink: 0,
    },
    '& [data-action-card-variant="noCard"]': {
      marginBlock: 'auto',
      flexShrink: 0,
    },
  }),
}));

export const Section = styled('div')({
  display: 'grid',
  gap: '12px',
  width: '100%',
});

const panelStyles: CSSProperties = {
  backgroundColor: COLORS.PRIMITIVES.WHITE,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  height: '100%',
};

export const Panel = ({
  variant = 'outlined',
  style,
  ...props
}: Partial<CardProps>) => {
  return (
    <Card variant={variant} style={{ ...panelStyles, ...style }} {...props} />
  );
};
